import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable()
export class CommunityService {

    private host: any = {};

    constructor(private client: HttpClient) {
        this.host['v2-community'] = environment.host('v2-community');
    }

    getMessage(messageId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-community']}/v2/community/admin/message/${messageId}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.getMessage.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.getMessage.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getComment(commentId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-community']}/v2/community/admin/comment/${commentId}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.getComment.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.getComment.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    browseMessages(before?: string): Observable<any> {
        const params: any = {};
        //params.skip = 0;
        //params.max = 100;
        //params.before = null;
        //params.after = null;
        if (before) {
            params.before = before;
        }
        return this.client.request('GET', `${this.host['v2-community']}/v2/community/admin/message`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            params: params
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.browseMessages.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.browseMessages.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    browseComments(messageId: string, before?: string): Observable<any> {
        const params: any = {};
        //params.skip = 0;
        //params.max = 100;
        //params.before = null;
        //params.after = null;
        if (before) {
            params.before = before;
        }
        return this.client.request('GET', `${this.host['v2-community']}/v2/community/admin/message/${messageId}/comment`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            params: params
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.browseComments.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.browseComments.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateMessageDeleted(messageId: string, value: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-community']}/v2/community/admin/message/${messageId}/deleted/${value}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.updateMessageDeleted.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.updateMessageDeleted.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateMessageInappropriate(messageId: string, value: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-community']}/v2/community/admin/message/${messageId}/inappropriate/${value}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.updateMessageInappropriate.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.updateMessageInappropriate.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateCommentDeleted(commentId: string, value: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-community']}/v2/community/admin/comment/${commentId}/deleted/${value}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.updateCommentDeleted.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.updateCommentDeleted.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateCommentInappropriate(commentId: string, value: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-community']}/v2/community/admin/comment/${commentId}/inappropriate/${value}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.updateCommentInappropriate.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.updateCommentInappropriate.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateUserBanned(userId: string, banned: boolean): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-community']}/v2/community/admin/user/${userId}/banned/${banned}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.updateUserBanned.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.updateUserBanned.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    likeMessage(messageId: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-community']}/v2/community/message/${messageId}/like`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.likeMessage.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.likeMessage.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    unlikeMessage(messageId: string): Observable<any> {
        return this.client.request('DELETE', `${this.host['v2-community']}/v2/community/message/${messageId}/like`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.unlikeMessage.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.unlikeMessage.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    postMessage(text: string): Observable<any> {
        return this.client.request('POST', `${this.host['v2-community']}/v2/community/message`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                text: text
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.postMessage.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.postMessage.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    postMessageWithFile(text: string, blob: any): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('photo', blob);
        formData.append('data', new Blob([JSON.stringify({ text: text })], { type: 'application/json' }));
        return this.client.request('POST', `${this.host['v2-community']}/v2/community/message`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: formData
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.postMessageWithFile.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.postMessageWithFile.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    postComment(text: string, messageId: string): Observable<any> {
        return this.client.request('POST', `${this.host['v2-community']}/v2/community/message/${messageId}/comment`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                text: text
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.postComment.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.postComment.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    sendNotification(title: string, body: string, topics: string[]): Observable<any> {
        return this.client.request('POST', `${this.host['v2-community']}/v2/community/admin/firebase/topic`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                "title": title,
                "body": body,
                "topics": topics,
                "data": {}
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('CommunityService.sendNotification.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('CommunityService.sendNotification.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }
}
